import React from "react";
import {QualityAction, QualityActionRestControllerApiFactory, QualityFinding} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {types} from "../../../../components/form/types";
import {useNavigate, useSearchParams} from "react-router-dom";

/** Una acción de un hallazgo (#13718). Se abre desde la ficha del hallazgo y vuelve a ella. */
export const QualityActionEditPage = () => {
	const apiManager = useApiManager();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const ctrl = apiManager.factory(QualityActionRestControllerApiFactory);
	const findingId = searchParams.get("findingId");
	const volver = () => navigate(findingId ? `/app/admin/compliance/finding/${findingId}` : "/app/admin/compliance/finding");

	const form = useForm({
		fetcher: (id) => ctrl.getQualityAction(id),
		updater: (bean) => ctrl.saveQualityAction(bean),
		remover: (id) => ctrl.deleteOrDismissQualityAction(id),
		factory: () => {
			const bean: Partial<QualityAction> = {status: "PENDIENTE", type: "CORRECTIVA"};
			if (findingId) {
				bean.finding = {id: Number(findingId)} as QualityFinding;
			}
			return bean as QualityAction;
		},
		postUpdate: () => volver(),
		postRemove: () => volver(),
	} as UseFormProps<QualityAction>);

	return (
		<FormContent form={form} title={"Acción"}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={3}>
					<FormSelect field={"type"} label={"Tipo"} type={types.qualityActionTypes}
								helperText={"Corrección: arregla el efecto. Correctiva: elimina la causa."}/>
				</Grid>
				<Grid item xs={12} sm={3}>
					<FormAutocomplete field={"responsible"} label={"Responsable"} type={types.people}/>
				</Grid>
				<Grid item xs={12} sm={2}>
					<FormInput field={"dueDate"} type={"date"} label={"Plazo"}/>
				</Grid>
				<Grid item xs={12} sm={2}>
					<FormSelect field={"status"} label={"Estado"} type={types.qualityActionStatuses}/>
				</Grid>
				<Grid item xs={12} sm={2}>
					<FormInput field={"doneDate"} type={"date"} label={"Hecha el"}/>
				</Grid>
			</Grid>
			<FormInput field={"description"} label={"Qué se hace"} rows={3}/>
			<FormInput field={"notes"} label={"Notas"} rows={2}/>
		</FormContent>
	);
};
